/**
 * 先生の申し込みフォームオブジェクト
 */
export class LineAfterUpdateParam {
  userId?: string;
  building?: string;
}
